export enum Feature {
  ActionableTaskView = 'Actionable Task View',
  AutomaticReports = 'Automatic Reports',
  AutoProvisioningSpotlight = 'AutoProvisioningSpotlight',
  BlockTeamlessBoards = 'Block Teamless Boards',
  BoardsPageTemplatePicker = 'Boards Page Template Picker',
  BoardTile = 'Board Tile',
  BoardViewsButton = 'Board Views Switcher',
  ButlerOnBoards = 'Butler on Boards',
  CalendarView = 'Calendar View',
  CardDetailDialog = 'Card Detail Dialog',
  CardFrontLinks = 'Card Front Links',
  CardTemplates = 'Card Templates',
  Checklists = 'Checklists',
  Collections = 'Collections',
  CovidChurn = 'Covid Churn',
  FreeTeamOnboarding = 'Free Team Onboarding',
  FreeTrialExistingTeam = 'Free Trial Existing Team',
  ExpiredFreeTrialExistingTeam = 'Expired Free Trial Existing Team',
  LinkCard = 'Link Card',
  LinkCardLoadAnalysis = 'Link Card Load Analysis',
  Madlibs = 'Madlibs',
  MemberBoardsPage = 'Member Boards Page',
  MigrationWizard = 'Migration Wizard',
  Moonshot = 'moonshot',
  MultiBoardTableView = 'Multi-Board Table View',
  NavigationMoreMenu = 'Navigation More Menu',
  NuSkuBillingView = 'NuSku Billing View',
  PluginPermissions = 'Plugin Permissions',
  ProjectBrita = 'Project Brita',
  PushTouchpointsSwitcherSpotlight = 'PushTouchpointsSwitcherSpotlight',
  RecentlyViewedBoardsMenu = 'Recently Viewed Boards Menu',
  SmartLink = 'Smart Link',
  StarredBoardsMenuButton = 'Starred Boards Menu Button',
  TableView = 'Table View',
  TeamEditAvatar = 'Team Edit Avatar',
  TeamOnboarding = 'Team Onboarding',
  TeamProfile = 'Team Profile Header',
  TeamTemplatePicker = 'Team Template Picker',
  TemplateCard = 'Template Card',
  TemplatePicker = 'Template Picker',
  TemplatesGallery = 'Templates Gallery',
  TemplatesInCreateFlow = 'Templates In Create Flow',
  TemplateTips = 'Template Tips',
  TimelineView = 'Timeline View',
  UndoAction = 'Undo Action',
  UpgradePrompt = 'Upgrade Prompt',
  WorkspaceBoardsPage = 'Workspace Boards Page',
  VideoRecordButton = 'Video Record Button',
  ViewSuggestionUpsell = 'View Suggestion Upsell Banner',
  WorkspaceNavigation = 'Workspace Navigation',
  WorkspaceSwitcher = 'Workspace Switcher',
  WorkspacesAutoNameAlert = 'Workspaces Auto Name Alert',
  WorkspacesPreamble = 'Workspaces Preamble',
  WorkspaceDefaultCustomTableView = 'Workspace Default Custom Table View',
}
